import { default as ObjectivesList } from './ObjectivesList';

export default ObjectivesList;
